var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#0C0D14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.717 21.1789C16.761 20.2229 16.761 18.6729 17.717 17.717C18.6729 16.761 20.2229 16.761 21.1789 17.717L28.75 25.2881L36.3211 17.717C37.2771 16.761 38.8271 16.761 39.783 17.717C40.739 18.6729 40.739 20.2229 39.783 21.1789L32.2119 28.75L39.783 36.3211C40.739 37.2771 40.739 38.8271 39.783 39.783C38.8271 40.739 37.2771 40.739 36.3211 39.783L28.75 32.2119L21.1789 39.783C20.2229 40.739 18.6729 40.739 17.717 39.783C16.761 38.8271 16.761 37.2771 17.717 36.3211L25.2881 28.75L17.717 21.1789Z",
    fill: "#F34D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFailed);
export default __webpack_public_path__ + "static/media/icon-failed.bbae065ad09d61452b7f278218a72819.svg";
export { ForwardRef as ReactComponent };